import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-weight-bold text-error mb-2"
}

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import { getApiBaseUrl } from '@/config/backendBaseUrl';
import { notifyErrorFromUnknown } from '@/utils/appNotify';


const __default__ = { name: 'AuthForm' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

const login = ref('');
const passwd = ref('');
const showPassword = ref(false);
const isLoading = ref(false);

const userData = computed((): Record<string, unknown> => {
  const u = store.getters['user/userData'];
  if (u == null || (Array.isArray(u) && u.length === 0)) {
    return {};
  }
  return u as Record<string, unknown>;
});

async function authorize() {
  isLoading.value = true;
  try {
    const body = new URLSearchParams();
    body.set('login', login.value);
    body.set('passwd', passwd.value);
    const response = await axios.post(`${getApiBaseUrl()}/ajax/user/userAuthorize/`, body);
    localStorage.setItem('userData', JSON.stringify(response.data));
    store.commit('user/setUserData', response.data);
  } catch (e: unknown) {
    notifyErrorFromUnknown(e);
  } finally {
    isLoading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "auth-card pa-6",
    elevation: "3",
    "max-width": "400",
    width: "100%",
    rounded: "lg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-h6 font-weight-medium pa-0 mb-1" }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Вход в прайс", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_card_subtitle, { class: "pa-0 mb-4 text-medium-emphasis" }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" Укажите учётные данные Bitrix ", -1)
        ]))]),
        _: 1
      }),
      (userData.value.auth === false)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Ошибка авторизации"))
        : _createCommentVNode("", true),
      _createVNode(_component_v_form, {
        "fast-fail": "",
        onSubmit: _withModifiers(authorize, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: login.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((login).value = $event)),
            density: "compact",
            label: "E-mail",
            autocomplete: "username",
            "prepend-inner-icon": "mdi-email-outline",
            variant: "outlined",
            "hide-details": "auto",
            class: "mb-2"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            modelValue: passwd.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwd).value = $event)),
            density: "compact",
            label: "Пароль",
            autocomplete: "current-password",
            "append-inner-icon": showPassword.value ? 'mdi-eye-off' : 'mdi-eye',
            type: showPassword.value ? 'text' : 'password',
            "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
            variant: "outlined",
            "hide-details": "auto",
            class: "mb-4"
          }, null, 8, ["modelValue", "append-inner-icon", "type"]),
          _createVNode(_component_v_btn, {
            type: "submit",
            block: "",
            color: "primary",
            size: "large",
            loading: isLoading.value
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Войти", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})